import './eurodima.css';
import './tyrolit.css';

export const THEMES = ['eurodima', 'tyrolit'] as const;
export const MODES = ['light', 'dark'] as const;

export type Theme = (typeof THEMES)[number];
export type Mode = (typeof MODES)[number];

export interface ThemeConfig {
  theme: Theme;
  mode: Mode;
}

export const DEFAULT_THEME: Theme = 'eurodima';
export const DEFAULT_MODE: Mode = 'light';
